import { Panel } from "components/panels";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  config: server.dto.DashboardWebDeveloperPanelConfig
}

const WebDeveloperPanel = (props: Props) => {
  return <Panel
    title={props.config.headerLabel}
    panelClassName="s1_dashboard-panel"
    contentCssClass="flex-column gap-small"
  >
    {props.config.canAccessWebforms && <div>
      <a href={routes.webform_List().absolute}>{RESX.Webform.Webforms}</a>
    </div>}

    {props.config.canAccessEmbedShows && <div>
      <a href={routes.embedShowsWizard().absolute}>{RESX.EmbedWizard.EmbedShowsOnYourSite}</a>
    </div>}
  </Panel>;
};

export default WebDeveloperPanel;
